import './PhoneMockup.css';

/** A CSS phone frame wrapping an app screenshot. */
export default function PhoneMockup({ src, alt, className = '' }) {
  return (
    <div className={`phone ${className}`.trim()}>
      <div className="phone__frame">
        <div className="phone__notch" aria-hidden="true" />
        <img className="phone__screen" src={src} alt={alt} loading="lazy" />
      </div>
    </div>
  );
}
